/*
 * Copyright (c) 2021. World Wide Generation Ltd
 */


export enum Action {
  Add = 'add',
  Remove = 'remove',
}
